export var LineStyleType;
(function (LineStyleType) {
    LineStyleType[LineStyleType["Solid"] = 0] = "Solid";
    LineStyleType[LineStyleType["Dash"] = 1] = "Dash";
    LineStyleType[LineStyleType["Dot"] = 2] = "Dot";
    LineStyleType[LineStyleType["DashDot"] = 3] = "DashDot";
    LineStyleType[LineStyleType["DashDotDot"] = 4] = "DashDotDot"; // 短线，点，点
})(LineStyleType || (LineStyleType = {}));
